import fmRESTorJS from '@/model/Restor'
import { constants } from '@/constants'

var sDomainOld = constants.server.domainOld;
var sDomainNew = constants.server.domain;
var isNewDom = Boolean(sDomainOld.normalize() !== sDomainNew.normalize());

export default class Model {

  constructor(login, password) {
    if (this.fm) {
      if (this.fm.isLogged()) {
        this.logout(1);
        // this.fm.logout( (requestSuccess) => {}, (requestError) => {} )
      }
    }
    this.fm = new fmRESTorJS(
      constants.server.domain, // cpf.in-format.com
      constants.project.database, // v7
      constants.project.layout, // APR_js
      login, 
      password
    )
  }

  isLogged() {
    return this.fm && this.fm.isLogged()
  }

  reconnectIfNeeded() {
    if (!this.isLogged()) {
      document.location.href='/'
    }
  }

  login() {
    const prom = new Promise((resolve, reject) => {
      this.fm.login(
        (requestSuccess) => {
          resolve(requestSuccess)
        },
        (requestError) => {
          console.error('login - error', requestError)
          reject(requestError)
        }
      )
    })
    return prom
  }

  logout(isForce=0,user=null) {
    console.log('🛑🛑🛑-logout');
    if (isForce || this.isLogged) {
      this.setUserTokens(user,"","").then(
        (requestSuccess) => { localStorage.removeItem("user-rec-id") },
        (requestError) => { console.error('setUserTokens : error', requestError) }
      );
      this.fm.logout(
        (requestSuccess) => { console.log('logout : success', requestSuccess) }, 
        (requestError) => { console.error('logout : error', requestError) }
      );
    }
  }

  getTokenName() {
    return this.fm.getTokenName();
  }

  getUser(login, password) {
    this.fm.setLayout('APR_js')
    const param = { 'query': [{
      'd011_login': login,
      'd012_mdp': password,
    }]}
    const prom = new Promise((resolve, reject) => {
      this.fm.findRecords(
        param,
        (requestSuccess) => {
          const data = requestSuccess.response.data[0].fieldData
          const user = {}
          user.login        = login
          user.zkp          = data.zkp
          user.recordId     = data.js_recordId
          user.firstName    = data.d001_prenom_ut
          user.lastName     = data.d002_nom_ut
          user.fullName     = data.w001_Identite_ct
          user.firstGhost   = data.d001_prenom_ghost_ut
          user.lastGhost    = data.d002_nom_ghost_ut
          user.tokenFM      = data.js_TokenFM_VueJs_st
          user.tokenID      = data.js_TokenID_VueJs_st
          user.signB64      = data.d072_Signature_Base64_ut // 'data:image/png;base64,'
          user.signOk       = Boolean(data.d075_IsSignature_cb)
          user.cguOk        = Boolean(data.js001_dateCgu) // (data.js001_dateCgu) ? 1 : 0
          user.ghostOk      = Boolean(data.js003_isGhost_ub)
          user.newIdnOk     = Boolean(data.js003_isNewIdn_ub)
          user.persoIdnOk   = Boolean(data.js003_isPersoIdn_cb)
          user.civility     = data.d000_civilite_unl
          user.birthday     = data.d070_Date_Naissance_ud
          user.phone        = data.d016_telephone
          user.mobile       = data.d017_mobile
          user.email        = data.d018_email
          user.metier       = data.d003_metier_ut
          user.connectTime  = Date.now()
          resolve(user)
        },
        (requestError) => {
          if (requestError.messages.code=="952") {
            // console.log('force logout')
            this.logout(1);
            // this.fm.logout()
          } else {
            console.error('getUser - error', requestError)
            reject(requestError)
          }
        }
      )
    })
    return prom
  }

  getUserUpdate(zkp) {
    this.fm.setLayout('APR_js')
    const param = { 'query': [{
      'zkp': zkp,
    }]}
    const prom = new Promise((resolve, reject) => {
      this.fm.findRecords(
        param,
        (requestSuccess) => {
          const data = requestSuccess.response.data[0].fieldData
          const user = {}
          user.firstName    = data.d001_prenom_ut
          user.lastName     = data.d002_nom_ut
          user.fullName     = data.w001_Identite_ct
          user.civility     = data.d000_civilite_unl
          user.birthday     = data.d070_Date_Naissance_ud
          user.phone        = data.d016_telephone
          user.mobile       = data.d017_mobile
          user.email        = data.d018_email
          user.metier       = data.d003_metier_ut
          resolve(user)
        },
        (requestError) => {
          if (requestError.messages.code=="952") {
            // console.log('force logout')
            this.logout(1);
            // this.fm.logout()
          } else {
            console.error('getUser - error', requestError)
            reject(requestError)
          }
        }
      )
    })
    return prom
  }

  setUserAcceptCgu(user) {

    this.reconnectIfNeeded()

    var parameters = {
      fieldData: { 
        js001_dateCgu: this.formatTimestamp(Date.now()),
      }
    }
    this.fm.setLayout('APR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.editRecord(

        user.recordId, parameters,
        
        (requestSuccess) => {
          resolve(true)
        },

        (requestError) => {
          console.error('setUserAcceptCgu - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom
  } // setUserAcceptCgu

  setUserTokens(user,tokenFM,tokenID) {

    this.reconnectIfNeeded()

    var recId = user.recordId || "";
    if (!user || !recId) recId = localStorage.getItem("user-rec-id") || "";
    // console.log('Model.setUserTokens:user-rec-id',recId);

    if (!recId) {
      console.error('setUserTokens - error : no recordID', recId);
      return false;
    }

    var parameters = {
      fieldData: { 
        js_TokenFM_VueJs_st: tokenFM,
        js_TokenID_VueJs_st: tokenID,
      }
    }
    this.fm.setLayout('APR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.editRecord(

        recId, parameters,
        
        (requestSuccess) => {
          resolve(true)
        },

        (requestError) => {
          console.error('setUserTokens - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom
  } // setUserTokens

  setUserDatas(user, bIdn, nCiv, sFirst, sLast, dBirth, sMetier, sMobile, sEmail) {

    /*
    this.model.setUserDatas(this.user, this.bPerso, this.nCiv, this.firstName, this.lastName, this.getDateConcat(false,true,'/'), this.sMetier, this.sMobile, this.sEmail);
    */

    this.reconnectIfNeeded()

    var recId = user.recordId || "";
    if (!user || !recId) recId = localStorage.getItem("user-rec-id") || "";
    // console.log('Model.setUserDatas:user-rec-id',recId);

    if (!recId) {
      console.error('setUserDatas - error : no recordID', recId);
      return false;
    }

    var parameters = {
      fieldData: { 
        d069_Date_Naissance_ut: '',
        d070_Date_Naissance_ud: '',
        js003_isNewIdn_ub: bIdn,
        d000_civilite_unl: nCiv,
        d001_prenom_ut: sFirst,
        d002_nom_ut: sLast,
        d003_metier_ut: sMetier,
        d017_mobile: sMobile,
        d018_email: sEmail,
        d069_Date_Naissance_ut: dBirth,
      }
    }
    this.fm.setLayout('APR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.editRecord(

        recId, parameters,
        
        (requestSuccess) => {
          resolve(true)
        },

        (requestError) => {
          console.error('setUserDatas - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom
  } // setUserDatas

  setUserSignature(user,signature) {

    this.reconnectIfNeeded()

    var recId = user.recordId || "";
    if (!user || !recId) recId = localStorage.getItem("user-rec-id") || "";
    // console.log('Model.setUserSignature:user-rec-id',recId);

    if (!recId) {
      console.error('setUserSignature - error : no recordID', recId);
      return false;
    }

    var parameters = {
      fieldData: { 
        d072_Signature_Base64_ut: '', 
        d073_Signature_Image_ume: '',
        d072_Signature_Base64_ut: signature, // 'data:image/png;base64,'
      }
    }
    this.fm.setLayout('APR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.editRecord(

        recId, parameters,
        
        (requestSuccess) => {
          resolve(true)
        },

        (requestError) => {
          console.error('setUserSignature - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom
  } // setUserSignature

  // ----------------------------------------------------------------------------------------------------

  getParams() {

    this.fm.setLayout('PAR_js');

    const requestResult = new Promise((resolve, reject) => {
      this.fm.getRecords(

        null,

        (requestSuccess) => {
          const requestData = requestSuccess.response.data[0].fieldData;
          const resultData = {
            assignmentTitle:      requestData.a001_Client_Nom_ut,
            cgu:                  requestData.a032_cgu,
            baseName:             requestData.ch00_nom_base_ct,
            canResetLesson:       requestData.i023_isLeconsInit,
            qstFixedHeightValue:  requestData.js001_qstFixedHeightValue,
            patienceTime:         requestData.js014_DureeSablier_cn,
            uploadSizeFiles:      requestData.js030_Upload_File_Size_un,
            uploadSizeVideos:     requestData.js031_Upload_Video_Size_un,
            isSignature:          Boolean(requestData.i048_isWebSignature_APR_ub),
            isSignChange:         Boolean(requestData.i049_isChangeSignature_APR_ub),
            isSignShowAuto:       Boolean(requestData.i050_isShowAutoSignature_APR_ub),
            isAprEditDatas:       Boolean(requestData.i051_isEditDatas_APR_ub),
            isAprChangeDatas:     Boolean(requestData.i052_isChangeDatas_APR_ub),
            isMediasTip:          Boolean(requestData.js015_isMediasTip_ub),
            isNotMultiConnect:    Boolean(requestData.js016_isNotMultiConnect_ub),
            isVueNewTable:        Boolean(requestData.js040_isVueNewTable_ub),
          };
          resolve(resultData);
        },

        (requestError) => {
          console.error('getParams - error', requestError);
          reject(requestError);
        }

      )
    });

    return requestResult;
    
  }

  // ----------------------------------------------------------------------------------------------------

  getDico(oDico) {
    var aDico = [];
    for (var itm of oDico) {
      aDico.push({
        term:    itm['lapr_DIC__zkfLec_2023::a01_Terme_ut'],
        defi:    itm['lapr_DIC__zkfLec_2023::a02_Definition_ut'],
        link:    itm['lapr_DIC__zkfLec_2023::a03_Lien_Infos_ut'],
        xid:     itm['lapr_DIC__zkfLec_2023::xId'],
        zkp:     itm['lapr_DIC__zkfLec_2023::zkp'],
      })
    };
    return aDico;
  }

  getSta(datas) {
    return {
      zkp:          datas['lapr_STA__zkfSta_2021::zkp'],
      isSeq:        datas['lapr_STA__zkfSta_2021::i004_isCoursSequentiel'],
      isSign:       datas['lapr_STA__zkfSta_2021::i019_APR_isSignature_ub'],
      title:        datas['lapr_STA__zkfSta_2021::js001_nomStage'],
      visioUrl:     datas['lapr_STA__zkfSta_2021::js021_VisioLinkStages_Url_ct'],
      isShow:       datas['lapr_STA__zkfSta_2021::js023_isPresentationMode_ub'],
      open:         true,
      sessions:     [], 
      courses:      [], 
    };
  }

  getSes(datas) {
    return {
      zkf_sta:      datas.zkf_sta,
      zkp:          datas['lapr_SES__zkfSes_2023::zkp'],
      dateDebut:    datas['lapr_SES__zkfSes_2023::js001_Debut_Date_ud'],
      forPass:      datas['lapr_SES__zkfSes_2023::js011_Formateur_Pass_ut'],
      open:         true,
    };
  }

  getMod(datas) {
    return {
      zkf_sta:      datas.zkf_sta,
      zkp:          datas['lapr_MOD__zkfMod_2021::zkp'],
      title:        datas['lapr_MOD__zkfMod_2021::js001_intitule_ut'],
      isLecSeq:     datas['lapr_MOD__zkfMod_2021::i003_isSequentiel'],
      trainer:      datas['lapr_FOR__zkf_2021::js001_civPrenomNom_ct'],
      open:         true,
      lessons:      [],
    };
  }

  getLec(datas, dico) {
    return {
      zkp:              datas.zkf_lec,
      zkf_mod:          datas.zkf_mod,
      zkp_lapr:         datas.zkp,
      recordId:         datas.js_recordId,
      zkf_sta:          datas.zkf_sta,
      zkf_ses:          datas.zkf_ses,
      trainName:        datas['lapr_STA__zkfSta_2021::js001_nomStage'],
      modeShow:         datas['lapr_STA__zkfSta_2021::js023_isPresentationMode_ub'],
      passEval:         datas['lapr_STA__zkfSta_2021::js019_Formateur_Pass_ut'],
      isLecInit:        datas['lapr_STA__zkfSta_2021::js007_isLeconsInit_ub'],
      forPass:          datas['lapr_SES__zkfSes_2023::js011_Formateur_Pass_ut'],
      isNoStopLec:      datas['lapr_SES__zkfSes_2023::js020_isNoStopLec_ub'],
      skillName:        datas['lapr_CMP__zkfCmp_2021::js001_intitule_ut'],
      langInfos:        datas['lapr_LEC__zkfLec_2021::d013_LangTextInfos_ut'],
      name:             datas['lapr_LEC__zkfLec_2021::js000_intitule_ut'],
      lang:             datas['lapr_LEC__zkfLec_2021::js001_langCode_ut'],
      country:          datas['lapr_LEC__zkfLec_2021::js001_countryCode_ut'],
      urlImage:         this.setNewDomain(datas['lapr_LEC__zkfLec_2021::js002_webLinkImg']),
      coachMustValid:   datas['lapr_LEC__zkfLec_2021::js009_isValidationAFaire'],
      audioTitle:       this.setNewDomain(datas['lapr_LEC__zkfLec_2021::js010_webLinkAudio']),
      isEvaluation:     datas['lapr_LEC__zkfLec_2021::js019_isEvaluation_ub'],
      isCheckExact:     datas['lapr_LEC__zkfLec_2021::js024_isCheckExact_ub'],
      isCheckIndice:    datas['lapr_LEC__zkfLec_2021::js024_isCheckIndice_ub'],
      answerGrp:        datas.js_groupeReponse_st,
      currQstZkp:       datas.js_zkpQuestionEnCours,
      histoQstZkp:      datas.js_zkpQuestionsNavHisto,
      state:            datas.js_etatLecon,
      ordre:            datas.js_LEC_ordre_n,
      startTime:        datas['lapr_LREP__zkfGrpLec_dateDebutLec_2021::t003_heureDebutLecon'],
      dictionary:       dico,
      visible:          true,
    };
  }

  // ----------------------------------------------------------------------------------------------------

  setAssignments(recordset) {
    var start = performance.now(); // Date.now();
    var nro_sta = 0;
    var nro_mod = 0;
    var nro_lec = 0;

    const aSTA = [];
    const aSES = [];
    const aMOD = [];
    const aLEC = [];

    // On récupère toutes les données de chaque niveau sans doublons

    // On boucle sur chaque enregistrement trouvé…
    for (const record of recordset) {

      const datas = record.fieldData;
      const dicos = record.portalData.lapr_DIC__zkfLec_2023;

      // Le dictionnaire
      const dico = (dicos.length) ? this.getDico(dicos) : [];

      // Selon qu'on est en mode session ou directement stage
      
      if (datas.js_IsSES_bc) {
        // Mode Session

        // Est-ce une session active ? 
        // (date courante comprise entre les dates de début et de fin de la session)
        
        if (datas['lapr_SES__zkfSes_2023::i003_IsActuel_cb']) {
          // Les stages
          if (!aSTA.some(t => t.zkp === datas.zkf_sta)) aSTA.push(this.getSta(datas));

          // Les sessions (données non utilisées… on désactive pour optimiser…)
          // if (!aSES.some(s => s.zkp === datas.zkf_ses)) aSES.push(this.getSes(datas));

          // Les cours
          if (!aMOD.some(m => m.zkp === datas.zkf_mod)) aMOD.push(this.getMod(datas));

          // Le leçons
          aLEC.push(this.getLec(datas, dico));
        };

      } else {
        // Mode Stage

        // Les stages
        if (!aSTA.some(t => t.zkp === datas.zkf_sta)) aSTA.push(this.getSta(datas));

        // Les cours
        if (!aMOD.some(m => m.zkp === datas.zkf_mod)) aMOD.push(this.getMod(datas));

        // Le leçons
        aLEC.push(this.getLec(datas, dico));

      };
      
    }; // for recordset


    // Ensuite on boucle sur les listes et on match avec les zkp et zkf

    for (var sta of aSTA) {
      
      // On filtre pour ne garder que les cours associés au stage actuel
      var mods = aMOD.filter(m => m.zkf_sta === sta.zkp);

      for (var mod of mods) {

        // On filtre pour ne garger que les leçons associées au cours actuel
        var lecs = aLEC.filter(l => l.zkf_mod === mod.zkp);

        for (var lec of lecs) {

          // Si la leçon n'existe pas dans le cours actuel, on la garde
          if (!mod.lessons.some(l => l.zkp === lec.zkp)) mod.lessons.push(lec);

        }; // for lecs

        // Si le cours n'existe pas dans le stage actuel, on le garde
        if (!sta.courses.some(c => c.zkp === mod.zkp)) sta.courses.push(mod);

      }; // for mods

    }; // for aSTA


    // On finalise tout ça…
    var end = performance.now(); // Date.now();
    console.log("setAssignments - Durée (ms) = ", end - start);

    return aSTA;
  } // setAssignments
  
  // ----------------------------------------------------------------------------------------------------

  getAssignments(userZkp) {
    // var start = performance.now(); // Date.now();

    this.reconnectIfNeeded()

    // Fredo 08/01/2022 : on filtre et tri les enregistrements de la table "LAPR" avec des rubriques
    // diréctement présentes, préremplies à l'étape d'affectation des apprenants.
    // Fredo 20/03/2022 : on ajoute le paramètre "limit" avec une valeur à "1000" pour pouvoir dépasser 
    // la limite des 100 réponses par défaut qu'impose la librairie "Restor.js"
    // https://fmhelp.filemaker.com/docs/18/en/dataapi/#perform-a-find-request
    // {fieldName: "lapr_SES__zkfSes_2023::js006_Debut_DateHeure_cn", sortOrder: "ascend"},
    const param = { 
      query: [{
        zkf_apr: userZkp,
        js_STA_IsShow_b: 1,
        js_SES_IsShow_b: 1,
        js_MOD_IsShow_b: 1,
        js_LEC_IsShow_b: 1,
      }],
      sort: [
        {fieldName: "LAPR__ligneApprenant_2021::js_STA_ordre_n", sortOrder: "ascend"},
        {fieldName: "LAPR__ligneApprenant_2021::js_SES_ordre_n", sortOrder: "ascend"},
        {fieldName: "LAPR__ligneApprenant_2021::js_MOD_ordre_n", sortOrder: "ascend"},
        {fieldName: "LAPR__ligneApprenant_2021::js_LEC_ordre_n", sortOrder: "ascend"},
      ],
      "limit": "10000"
    }
    // console.log('param', param);

    let recordset = []
    this.fm.setLayout('LAPR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.findRecords(

        param,

        (requestSuccess) => {
          var assignments = this.setAssignments(requestSuccess.response.data);
          resolve({
            assignments,
          })
        },

        (requestError) => {
          console.error('getAssignment - error', requestError)
          reject(requestError)
        }

      )
    })
    
    // var end = performance.now(); // Date.now();
    // console.log("getAssignments - Durée (ms) = ", end - start);

    return prom;
  }

  // ----------------------------------------------------------------------------------------------------

  setLesson(recordset) {
    var lessons = []
    // On boucle sur chaque enregistrement trouvé…
    for (const record of recordset) {
      // ntot++;
      const datas = record.fieldData;
      var lesson  = {
        zkp_lapr:         datas.zkp,
        zkf_mod:          datas.zkf_mod,
        zkf_sta:          datas.zkf_sta,
        isLecInit:        datas['lapr_STA__zkfSta_2021::js007_isLeconsInit_ub'],
        langInfos:        datas['lapr_LEC__zkfLec_2021::d013_LangTextInfos_ut'],
        name:             datas['lapr_LEC__zkfLec_2021::js000_intitule_ut'],
        lang:             datas['lapr_LEC__zkfLec_2021::js001_langCode_ut'],
        country:          datas['lapr_LEC__zkfLec_2021::js001_countryCode_ut'],
        coachMustValid:   datas['lapr_LEC__zkfLec_2021::js009_isValidationAFaire'],
        isEvaluation:     datas['lapr_LEC__zkfLec_2021::js019_isEvaluation_ub'],
        answerGrp:        datas.js_groupeReponse_st,
        state:            datas.js_etatLecon,
        }
    }
    // console.log('lesson', lesson)
    return lesson
  }

  getLesson(userZkp,sesZkp,lecZkp) {
    // var start = performance.now(); // Date.now();

    this.reconnectIfNeeded()

    const param = { 
      query: [{
        zkf_apr: userZkp,
        zkf_ses: sesZkp,
        zkf_lec: lecZkp,
      }],
      "limit": "10000"
    }
    // console.log('param', param);

    let recordset = []
    this.fm.setLayout('LAPR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.findRecords(

        param,

        (requestSuccess) => {
          var lesson = this.setLesson(requestSuccess.response.data);
          resolve(lesson)
        },

        (requestError) => {
          console.error('getLesson - error', requestError)
          reject(requestError)
        }

      )
    })
    
    // var end = performance.now(); // Date.now();
    // console.log("getAssignments - Durée (ms) = ", end - start);

    return prom;
  }

  // ----------------------------------------------------------------------------------------------------

  computeQuestions(recordset) {
    var questions = []
    var q = 0;
    for (var recQuestion of recordset) {
      var question  = {}
      var qstData = recQuestion.fieldData;
      question.typeQuestion = (
        qstData.js031_isPieceJointe
        ? constants.typeQuestion.upload
        : qstData.js011_typeQuestion_unl
      )
      question.index = q++;
      question.typeContent = qstData.js009_typeContenu_unl
      question.urlImage = this.setNewDomain(qstData.js005_webLinkImg);
      question.urlVideo = this.setNewDomain(qstData.js013_webLinkVideo);
      question.urlDoc = this.setNewDomain(qstData.js014_webLinkDoc);
      question.urlHtml = this.setNewDomain(qstData.js015_webLinkHtml);
      // @@@ Fredo : on récupère le lien vers la miniature du site (si elle existe)
      question.urlHtmlThumbn = this.setNewDomain(qstData.js0154_webLinkThumbn_Link_ut);
      question.urlIsEmbed = qstData.js0155_webLink_isEmbed_ub
      question.title = qstData.js006_titreQst
      question.message = qstData.js021_messageCss_ct
      question.question = qstData.js004_question
      question.order = qstData.js003_numQst
      question.final = qstData.js012_qstFinal
      question.audioTitle = this.setNewDomain(qstData.js027_weblinkAudioTitre);
      question.audioMessage = this.setNewDomain(qstData.js028_weblinkAudioMessage);
      question.audioQuestion = this.setNewDomain(qstData.js029_weblinkAudioQst);
      // @@@ Fredo : rubrique "repLibreType" réponse libre de type : 1 = texte ; 2 = date ; 3 = heure ; 4 = nombre
      question.repLibreType = qstData.js040_repLibreType_un
      question.isRepPlage = qstData.js044_isRepLibrePlage_ub
      question.repLibreUnit = qstData.js045_repNombreUnite_ut
      question.repLibreLabel = qstData.js046_repNombreLabel_ut
      question.repDateOkMin = qstData.js0472_repDateOkMin_ct
      question.repDateOkMax = qstData.js0473_repDateOkMax_ct
      question.repHeureOkMin = qstData.js0482_repHeureOkMin_ct
      question.repHeureOkMax = qstData.js0483_repHeureOkMax_ct
      question.repNombreOkMin = qstData.js0490_repNombreOkMin_un
      question.repNombreOkMax = qstData.js0491_repNombreOkMax_un
      question.isVignette = qstData.i051_isVignette_cb
      question.vignetteUrl = this.setNewDomain(qstData.js052_vignetteWebLink);
      question.vignettePos = qstData.js053_vignettePosition_ub
      question.vignetteDim = qstData.js054_vignetteDimension_un
      question.nbrPrpAll = qstData.v010_nbr_PRP_Total_cn
      question.nbrPrpOk = qstData.v011_nbr_PRP_isBonne_cn
      question.zkp = qstData.zkp
      question.props = []
      var i = 0
      for (var recProp of recQuestion.portalData.qst_PRP__zkfQst_2021) {
        var prop = {}
        prop.index = i++
        prop.zkp = recProp['qst_PRP__zkfQst_2021::zkp']
        prop.prop = recProp['qst_PRP__zkfQst_2021::js000_proposition']
        prop.isPropOk = recProp['qst_PRP__zkfQst_2021::i001_isPropBonne_ub']
        prop.zkpNextQuestion = recProp['qst_PRP__zkfQst_2021::zkf_qstSuiv']
        prop.audioTitle = this.setNewDomain(recProp['qst_PRP__zkfQst_2021::js004_weblinkAudioTitre']);
        question.props.push(prop)
      }
      questions.push(question)
    }
    // console.log('questions', questions)
    return questions

  }

  getQuestions(lessonZkp) {

    this.reconnectIfNeeded()

    this.fm.setLayout('QST_js')

    // Fredo 20/03/2022 : on ajoute le paramètre "limit" avec une valeur à "10000" pour pouvoir dépasser 
    // la limite des 100 réponses par défaut qu'impose la librairie "Restor.js"
    // https://fmhelp.filemaker.com/docs/18/en/dataapi/#perform-a-find-request
    const constants = { 
      query: [
        { zkf_lec: lessonZkp }
      ],
      "limit": "10000"
    }
    
    const prom = new Promise((resolve, reject) => {
      this.fm.findRecords(

        constants,
        
        (requestSuccess) => {
          console.log('getQuestions - success', requestSuccess.response.data)
          let questions = this.computeQuestions(requestSuccess.response.data)
          resolve(questions)
        },
   
        (requestError) => {
          console.error('getQuestions - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom
  }

  // ----------------------------------------------------------------------------------------------------

  computeDictionray(recordset) {
    var dictionary = []
    for (var recDico of recordset) {
      var dico  = {}
      dico.term = recDico.fieldData.a01_Terme_ut
      dico.definition = recDico.fieldData.a02_Definition_ut
      dico.link = recDico.fieldData.a03_Lien_Infos_ut
      dico.zkp = recDico.fieldData.zkp
      dico.xid = recDico.fieldData.xId
      dictionary.push(dico)
    }
    // console.log('dictionary', dictionary)
    return dictionary
  }
  // DIC_dico::
  /*
      sort: [
        {fieldName: "DIC_dico::a01_Terme_ut", sortOrder: "ascend"},
      ],
  */
  getDictionary(lessonZkp) {
    this.reconnectIfNeeded()
    this.fm.setLayout('DIC_js')
    const constants = { 
      query: [
        { zkl_lec: lessonZkp }  
      ],
      "limit": "10000"
    }
    const prom = new Promise((resolve, reject) => {
      this.fm.findRecords(
        constants,
        (requestSuccess) => {
          let dictionary = this.computeDictionray(requestSuccess.response.data)
          resolve(dictionary)
        },
        (requestError) => {
          console.error('getDictionary - error', requestError)
          reject(requestError)
        }
      )
    })
    return prom
  }

  // ----------------------------------------------------------------------------------------------------

  saveAnswer(
    question, user, lesson, 
    answer, lessonStartTime, lessonEndTime, questionStartTime, questionEndTime, answerStartTime, answerEndTime, isAnswerOk, isVueNewTable
  ) {

    this.reconnectIfNeeded()

    // console.log('saveAnswer question', question)
    // console.log('saveAnswer lesson', lesson)
    // console.log('saveAnswer questionEndTime', questionEndTime)

    // Fredo 17/12/2021 : On récupère la fin de leçon directement de "Question.vue"

    const constants = {
      fieldData: {
        zkf_qst: question.zkp,
        zkf_apr: user.zkp,
        zkf_sta: lesson.zkf_sta,
        zkf_ses: lesson.zkf_ses,
        zkf_lec: lesson.zkp,
        zkf_mod: lesson.zkf_mod,
        js_groupeReponse: lesson.answerGrp,
        js001_zkf_prp: answer,
        js0010_IsAnswerOk_sb: isAnswerOk,
        t001_dateHeureDebutConnexion: this.formatTimestamp(user.connectTime),
        t003_heureDebutLecon: this.formatTimestamp(lessonStartTime),
        t004_heureFinLecon: this.formatTimestamp(lessonEndTime),
        t005_heureDebutQuestion: this.formatTimestamp(questionStartTime),
        t006_heureFinQuestion: this.formatTimestamp(questionEndTime),
        t009_heureDebutReponse: this.formatTimestamp(answerStartTime),
        t010_heureFinReponse: this.formatTimestamp(answerEndTime),
      }
    }

    // console.log('saveAnswer constants', constants)

    // const isVueNewTable = this.$store.state.params.isVueNewTable;
    console.log('isVueNewTable', Number(isVueNewTable))

    if (isVueNewTable) {
      this.fm.setLayout('LRET_js')
    } else {
      this.fm.setLayout('LREP_js')
    }

    const prom = new Promise((resolve, reject) => {
      this.fm.createRecord(

        constants,
        
        (requestSuccess) => {
          resolve(true)
        },

        (requestError) => {
          console.error('saveAnswerData - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom

  } // saveAnswer
  
  saveCurrQst(question, lesson) {

    this.reconnectIfNeeded()

    const parameters = {
      fieldData: { 
        js_zkpQuestionEnCours: question.zkp,
        js_zkpQuestionsNavHisto: f_getQstZkpAll_v(true),
      }
    }
    this.fm.setLayout('LAPR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.editRecord(

        lesson.recordId, parameters,
        
        (requestSuccess) => {
          resolve(true)
        },

        (requestError) => {
          console.error('saveCurrQst - error', requestError)
          reject(requestError)
        }
  
      )
    })
    return prom

  } // saveCurrQst  

  // ----------------------------------------------------------------------------------------------------

  runScript(layout, scriptName, parameter) {

    this.reconnectIfNeeded()
    this.fm.setLayout(layout)
    console.log('layout / scriptName : ', layout + ' / ' + scriptName)
    console.log(parameter)
    const prom = new Promise((resolve, reject) => {
      this.fm.runScript(

        scriptName,
        {
          "script.param": parameter,
        },
        
        (requestSuccess) => {
          console.log('runScript - success', requestSuccess)
          this.fm.setLayout('APR_js')
          resolve(true)
        },

        (requestError) => {
          console.error('runScript - error', requestError)
          this.fm.setLayout('APR_js')
          reject(requestError)
        }
  
      )
    })
    return prom

  } // saveCurrQst  

  
  // ----------------------------------------------------------------------------------------------------

  formatTimestamp(timestamp) {
    var result
    if (timestamp) {
      result = new Date(timestamp)        // 1619114253891
      result = result.toLocaleString('en-US') // 4/22/2021, 7:57:33 PM
      result = result.replace(' ', '')        // 4/22/2021,7:57:33 PM
      result = result.replace(',', ' ')       // 4/22/2021 7:57:33 PM : accepted FM timestamp format
    } else {
      result = ''
    }
    return result
  }

  setNewDomain(sText) {
    //* Méthode pour remplacer l'ancien domaine par le nouveau dans les chemins d'accès
    if (isNewDom) return sText.replace(sDomainOld, sDomainNew);
    return sText;
  }

  // ----------------------------------------------------------------------------------------------------

  test() {

    this.fm.setLayout('LAPR_js')
    const prom = new Promise((resolve, reject) => {
      this.fm.runScript(
        
        'testYvan', 
        
        {
          "script.param": '12|4',
        },
        
        (requestSuccess) => {
          console.log('runScript - success', requestSuccess)
          resolve(requestSuccess)
        },
   
        (requestError) => {
          console.error('runScript - error', requestError)
          reject(requestError)
        }
  
      )
    })
  }

}




// WEBPACK FOOTER //
// ./src/model/Model.js